import React from "react";
import { Row, Col } from "react-bootstrap";

import "./MedicalTourism4.css";

const competencies = [
  {
    icon:"/assets/planning.svg",
    title: "Planning",
    desc: "Mapping your treatment, travel, and recovery into one clear itinerary.",
  },
  {
    icon: "/assets/Guidance.svg",
    title: "Guidance",
    desc: "A dedicated advisor answering questions at every stage, in your language.",
  },
  {
    icon: "/assets/facilitation.svg",
    title: "Facilitation",
    desc: "Handling hospital admission, documentation, and payments on the ground.",
  },
  {
    icon: "/assets/Advising.svg",
    title: "Advising",
    desc: "Honest second opinions so every decision is made with full information.",
  },
];

const MedicalTourism4 = () => {
  return (
    <section className="coreCompetencies standard-padding">
      <h1 className="heading text-center mb-5">
        Our Core Competencies
      </h1>

      <Row className="g-4">
        {competencies.map((item, index) => (
          <Col xl={3} lg={3} md={6} sm={6} xs={12} key={index}>
            <div className="competencyCard">
              <div className="competencyIcon">
                <img src={item.icon} alt={item.title} />
              </div>

              <h4 className="competencyTitle">
                {item.title}
              </h4>

              <p className="competencyDesc text">
                {item.desc}
              </p>
            </div>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default MedicalTourism4;